import React from 'react';
import { useTranslation } from 'react-i18next';
import { clampProgress, isJobActive } from './podcastJob';

const STATUS_CLASSES = {
  queued: 'bg-gray-100 text-gray-800',
  running: 'bg-yellow-100 text-yellow-800',
  done: 'bg-green-100 text-green-800',
  failed: 'bg-red-100 text-red-800'
};

export const StatusBadge = ({ status }) => {
  const { t } = useTranslation();
  const key = STATUS_CLASSES[status] ? status : 'queued';
  return (
    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${STATUS_CLASSES[key]}`}>
      {t(`podcasts.status.${key}`)}
    </span>
  );
};

// Status w tabeli: plakietka + pasek postępu i krok dla aktywnych zadań.
const PodcastStatus = ({ job }) => {
  const { t } = useTranslation();
  const active = isJobActive(job);
  const progress = clampProgress(job?.progress);
  const stepKey = job?.status === 'queued' ? 'queued' : job?.step;

  return (
    <div className="min-w-[140px] max-w-[220px]">
      <StatusBadge status={job?.status} />
      {active && (
        <div className="mt-1.5" data-testid="podcast-row-progress">
          <div
            className="h-1.5 w-full rounded-full bg-gray-100 overflow-hidden"
            role="progressbar"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={progress}
            aria-label={t('podcasts.progress.title')}
          >
            <div className="h-full rounded-full bg-primary-500 transition-all duration-500" style={{ width: `${progress}%` }} />
          </div>
          <div className="mt-1 text-[11px] text-gray-500">
            {stepKey ? t(`podcasts.steps.${stepKey}`) : null} · {progress}%
          </div>
        </div>
      )}
      {job?.status === 'failed' && job?.error && (
        <div className="mt-1 text-[11px] text-red-700 truncate" title={job.error}>
          {job.error}
        </div>
      )}
    </div>
  );
};

export default PodcastStatus;
